import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import {
  addPhaseDependencyInProjectTemplate,
  AddPhaseDependencyInProjectTemplatePayload,
} from '../../actions';
import { addProjectTemplatePhaseDependency } from '../../slices';

function* addTemplatePhaseDependencySaga(
  action: StoreActionProps<AddPhaseDependencyInProjectTemplatePayload>,
) {
  try {
    const {
      payload: { phaseId, dependentPhaseId },
    } = action;

    yield put(
      addProjectTemplatePhaseDependency({
        dependentPhaseId,
        phaseId,
      }),
    );
  } catch (error) {
    logger.error('addProjectTemplatePhaseDependency failed', { error });

    message.error(
      'There was an error updating phase dependencies, please try later',
    );
  }
}

export function* watchAddTemplatePhaseDependencySaga(): Generator {
  yield takeLatest(
    addPhaseDependencyInProjectTemplate.type,
    addTemplatePhaseDependencySaga,
  );
}
